export default __webpack_public_path__ + "static/media/Q12023.63c32b78.pdf";